/*=========================================================================================
  File Name: state.js
  Description: Orders State
  ----------------------------------------------------------------------------------------
  Item Name: Orders Module
  Author: Tan Tran
==========================================================================================*/

export default {

    ordersByDate : []
  
  } 